import { create } from 'zustand';

export const useLeadSidebarStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openLeadSidebar: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null };
  }),
}));
export const openLeadSidebar = (payload) => {
  const store = useLeadSidebarStore.getState();
  store.openLeadSidebar(payload);
};

export const closeLeadSidebarCreate = () => {
  const store = useLeadSidebarStore.getState();
  store.close();
};